export default __webpack_public_path__ + "static/media/purple.cc6b72bc.png";